<template>
  <div class="PlatformProjectDetailsView">
    <ShPageHeader :title="`Projekt: ${projectName || '--' }`"
                  description="Poniżej znajdują się szczegółowe informacje dotyczące projektu IVR."
                  :breadcrumb-items="[
                    { label: 'zarządzanie' },
                    { label: `Projekt: ${projectName || '--' }`, path: '/project-details' }
                  ]"
    />
    <ShPageLayout>
      <CustomTabs active-tab="main"
                  :tabs="[
                    { name: 'main', label: 'Podstawowe dane i ustawienia', isVisible: this.$store.getters['authorization/acl'].hasPermission('project_details_access') },
                    { name: 'messages', label: 'Komunikaty Podstawowe', isVisible: this.$store.getters['authorization/acl'].hasPermission('project_messages_access') },
                    { name: 'agents', label: 'Agenci / Placówki', isVisible: this.$store.getters['authorization/acl'].hasPermission('agents_access') },
                    { name: 'holidays', label: 'Święta i dni wolne', isVisible: holidaysVisible && this.$store.getters['authorization/acl'].hasPermission('holidays_access')},
                  ]"
      >
        <template #main>
          <el-row :gutter="20">
            <el-col :span="12">
              <ProjectMainData v-if="$store.getters['authorization/acl'].hasPermission('project_details_access')"
                               :project-uuid="projectUuid"
              />
            </el-col>
            <el-col v-if="$store.getters['authorization/acl'].hasPermission('project_basic_configuration')"
                    :span="12"
            >
              <ProjectBasicConfiguration :project-uuid="projectUuid" />
            </el-col>
          </el-row>
          <el-row v-if="$store.getters['authorization/acl'].hasPermission('project_agents_groups')"
                  :gutter="20"
          >
            <el-col :span="12">
              <IvrProjectAgentGroupsList :project-uuid="projectUuid" />
            </el-col>
          </el-row>
        </template>
        <template #messages>
          <IvrBasicMessages :project-uuid="projectUuid" />
        </template>
        <template #agents>
          <AgentsList :project-uuid="projectUuid" />
        </template>
        <template #holidays>
          <HolidaysList :project-uuid="projectUuid"/>
        </template>
      </CustomTabs>
    </ShPageLayout>
    <ShSideBarModal :side-bar-modal-visibility.sync="isModalWithAgentDetailsVisible"
                    :title="'Detale Agenta / Placówki'"
                    :description="'Poniżej znajdują się detale Agenta lub Placówki'"
                    @closeModal="isModalWithAgentDetailsVisible = false"
    >
      <AgentDetailsAndEditForm slot="content"
                               :agent-uuid="agent"
                               @closeModal="isModalWithAgentDetailsVisible = false"
      />
    </ShSideBarModal>
  </div>
</template>

<script>
import ProjectMainData from '@/components/Projects/ProjectMainData';
import ProjectBasicConfiguration from '@/components/Projects/ProjectBasicConfiguration';
import IvrBasicMessages from '@/components/Projects/IvrMessages/IvrBasicMessages';
import AgentsList from '@/components/Projects/Agents/AgentsList';
import AgentDetailsAndEditForm from '@/components/Projects/Agents/AgentDetailsAndEditForm';
import HolidaysList from '@/components/Projects/Holidays/HolidaysList';
import IvrProjectAgentGroupsList from '@/components/Projects/IvrProjectAgentGroupsList';
import CustomTabs from '@/components/Common/CustomTabs';
import { customValidations } from '@/mixins';

export default {
  name: 'PlatformProjectDetails',

  components: {
    ProjectMainData,
    ProjectBasicConfiguration,
    IvrBasicMessages,
    AgentsList,
    AgentDetailsAndEditForm,
    HolidaysList,
    IvrProjectAgentGroupsList,
    CustomTabs,
  },
  mixins: [customValidations],

  data() {
    return {
      projectUuid: null,
      agent: {},
      isModalWithAgentDetailsVisible: false,
    };
  },

  computed: {
    projectName() {
      return this.$store.getters['client/project/details']?.name;
    },
    holidaysVisible() {
      return this.$store.getters['client/project/details']?.check_holiday;
    },
  },
  created() {
    if (this.mUuidValidation(this.$route.params.projectUuid)) {
      this.projectUuid = this.$route.params.projectUuid;
    } else {
      this.$router.push({ name: 'PlatformProjects' });
    }
  },
  mounted() {
    this.$EventBus.$on('SHOW_AGENT_DETAILS', (agent) => {
      this.agent = agent;
      this.isModalWithAgentDetailsVisible = true;
    });
  },
  beforeDestroy() {
    this.$EventBus.$off('SHOW_AGENT_DETAILS');
  },
};
</script>
